import React from 'react';
import { Helmet } from 'react-helmet-async';
import './MaintenancePage.css';

function MaintenancePage() {
  return (
    <>
      <Helmet>
        <title>Sivusto on toistaiseksi poissa käytöstä</title>
        <meta
          name="description"
          content="Palvelu ei ole tällä hetkellä aktiivisessa käytössä."
        />
        <meta name="robots" content="noindex, nofollow, noarchive" />
      </Helmet>

      <main className="maintenance-page">
        <section
          className="maintenance-page__content"
          aria-labelledby="maintenance-title"
        >
          <p className="maintenance-page__label">Fourplify</p>
          <h1 id="maintenance-title">Sivusto on toistaiseksi poissa käytöstä</h1>
          <p>Palvelu ei ole tällä hetkellä aktiivisessa käytössä.</p>
        </section>
      </main>
    </>
  );
}

export default MaintenancePage;
